import store from "../store";

import { getLicenseInfo, getLicenseInfoOption } from "../api/system";

const toStringAndSort = (x) => {
    if (["boolean", "string", "number"].includes(typeof x)) return x;
    if (typeof x == "object") {
        if (Array.isArray(x)) {
            return JSON.stringify(x.sort());
        }
        let obj = {};
        Object.keys(x)
            .sort()
            .forEach((key) => {
                obj[key] = x[key];
            });
        return JSON.stringify(obj);
    }
};

const toJsonIfItIs = (x) => {
    try {
        // Javascript 陷阱, 字串會被轉換成數字或是布林
        return JSON.parse(x);
    } catch (err) {
        return x;
    }
};

const random_rgba = () => {
    var o = Math.round,
        r = Math.random,
        s = 255;
    return "rgba(" + o(r() * s) + "," + o(r() * s) + "," + o(r() * s) + "," + r().toFixed(1) + ")";

    function random_rgba() {
        var o = Math.round,
            r = Math.random,
            s = 255;
        return "rgba(" + o(r() * s) + "," + o(r() * s) + "," + o(r() * s) + "," + r().toFixed(1) + ")";
    }
};

function randomDarkColor() {
    var lum = -0.25;
    var hex = String("#" + Math.random().toString(16).slice(2, 8).toUpperCase()).replace(/[^0-9a-f]/gi, "");
    if (hex.length < 6) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    var rgb = "#",
        c,
        i;
    for (i = 0; i < 3; i++) {
        c = parseInt(hex.substr(i * 2, 2), 16);
        c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
        rgb += ("00" + c).substr(c.length);
    }
    return rgb;
}

function wafActionToString(action) {
    let actionDic = {
        "00": "Allow",
        "01": "Deny",
        "03": "Gesture",
        "04": "Log",
        "05": "Speed",
        "06": "Redirect",
        "07": "Cookie",
        "08": "Block Period",
        "09": "Request Headers",
        10: "Response Headers",
        11: "Log Only",
        12: "Custom Page",
        13: "Origin Policy",
        14: "Smart Captcha",
        15: "Scroll",
        16: "Hotlink",
    };
    return actionDic[action] || action;
}

function wafCodeToValue(wafCode) {
    let actionDic = {
        "00": "",
        "01": "deny",
        "03": "vaptcha",
        "04": "",
        "05": "",
        "06": "",
        "07": "",
        "08": "bucket",
        "09": "",
        10: "",
        11: "",
        12: "",
        13: "",
        14: "captcha",
        15: "",
        16: "hotlink",
    };
    return actionDic[wafCode];
}

function _debounce(func, wait = 500) {
    let timer = null;

    return function () {
        let context = this;
        let args = arguments;

        clearTimeout(timer);
        timer = setTimeout(() => func.apply(context, args), wait);
    };
}

function isSameJson(j1, j2) {
    return JSON.stringify(j1) == JSON.stringify(j2);
}

function buildQueryString(params) {
    let queryString = Object.keys(params)
        .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
        .join("&");
    return queryString;
}

function _uuid() {
    var d = Date.now();
    if (typeof performance !== "undefined" && typeof performance.now === "function") {
        d += performance.now(); //use high-precision timer if available
    }
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
    });
}

function isValidJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

const timeUnitOption = {
    min: 1,
    hour: 60,
    day: 60 * 24,
    month: 60 * 24 * 30,
};

function getMinutesByUnit(unitValue, unit) {
    return unitValue * timeUnitOption[unit];
}
function getCacheLimitByUnit(unit) {
    let { currentPlan } = store.state.platformPlan;
    let planData = store.state.platformPlan.planSpec.find((e) => e.planName == currentPlan);
    switch (unit) {
        case "hour":
            return {
                min: planData.cacheLimitByUnit.hour.min,
                max: planData.cacheLimitByUnit.hour.max,
            };
            break;
        case "day":
            return {
                min: planData.cacheLimitByUnit.day.min,
                max: planData.cacheLimitByUnit.day.max,
            };
            break;
        case "month":
            return {
                min: planData.cacheLimitByUnit.month.min,
                max: planData.cacheLimitByUnit.month.max,
            };
            break;
        default:
            return {
                min: planData.cacheLimitByUnit.default.min,
                max: planData.cacheLimitByUnit.default.max,
            };
    }
}

function minToUnit(min) {
    return min < timeUnitOption.hour
        ? "min"
        : min >= timeUnitOption.hour && min < timeUnitOption.day
        ? "hour"
        : min >= timeUnitOption.day && min < timeUnitOption.month
        ? "day"
        : "month";
}

function transferValueByUnit(value, unit) {
    switch (unit) {
        case "hour":
            return value / timeUnitOption.hour;
            break;
        case "day":
            return value / timeUnitOption.day;
            break;
        case "month":
            return value / timeUnitOption.month;
            break;
        default:
            return value / timeUnitOption.min;
    }
}

const getTimeRangeOptions = async ({ dateRangeKey = "" }) => {
    const result = { dateRangeLimit: 90, timeRangeOptions: [] };

    // 取得後台配置
    const licenseInfo = await getLicenseInfo();
    if (!licenseInfo.data.success) {
        return result;
    }

    // 抓取後台配置的dashboardTimeRange參數
    const dashboardTimeRange = licenseInfo.data.mapData.find((license) => license.name === "dashboardTimeRange");
    const dashBoardTimeRangeItems = dashboardTimeRange[dateRangeKey] || [];

    // 沒找到設定
    if (dashBoardTimeRangeItems.length === 0) {
        return result;
    }

    // 抓取下拉清單
    const selectOptions = await getLicenseInfoOption();
    if (!selectOptions.data.success) {
        return result;
    }

    // 沒找到設定
    const requestSummaryOptions = selectOptions.data.mapData[dateRangeKey].value;
    if (requestSummaryOptions.length === 0) {
        return result;
    }

    // 比對後台配置與下拉清單選項將label設定上
    result.timeRangeOptions = dashBoardTimeRangeItems.map((item) => {
        const findSelectOption = requestSummaryOptions.find((e) => e.value === item.value);
        // 有比對到回傳下拉清單選項
        if (findSelectOption) {
            return findSelectOption;
        }
        return item;
    });

    // 抓取 custom 的日期範圍
    const targetItem = dashBoardTimeRangeItems.find((item) => item.value === "99");
    result.dateRangeLimit = targetItem ? targetItem.dateRangeLimit : 0;

    return result;
};

// 依照 groupName 進行排序（支援數字排序與忽略大小寫）
function sortGroupRoles(list = []) {
    return [...list].sort((a, b) =>
        (a.groupName || "").localeCompare(b.groupName || "", "en", {
            numeric: true,
            sensitivity: "base",
        })
    );
}

export {
    toStringAndSort,
    toJsonIfItIs,
    random_rgba,
    randomDarkColor,
    wafActionToString,
    wafCodeToValue,
    _debounce,
    isSameJson,
    buildQueryString,
    _uuid,
    isValidJsonString,
    minToUnit,
    transferValueByUnit,
    getMinutesByUnit,
    timeUnitOption,
    getCacheLimitByUnit,
    getTimeRangeOptions,
    sortGroupRoles,
};



// WEBPACK FOOTER //
// ./src/libs/utils.js